import React from "react";
import {
	OrganizationContentTitle,
	OrganizationContentTitleWrapper,
	OrganizationContentWrapper,
} from "./style";
import { useSelector } from "react-redux";
import { getIsLoading } from "@/redux/global/selector";
import Loader from "@/components/Loader";

interface IOrganizationContent extends React.Attributes {
	title: string;
	children: React.ReactNode;
	actions?: React.ReactNode;
}

export const OrganizationContent = ({
	title,
	children,
	actions,
}: IOrganizationContent) => {
	const isLoading = useSelector(getIsLoading);

	return (
		<OrganizationContentWrapper>
			{isLoading ? (
				<Loader fixed={false} />
			) : (
				<>
					<OrganizationContentTitleWrapper>
						<OrganizationContentTitle>{title}</OrganizationContentTitle>
						{actions || null}
					</OrganizationContentTitleWrapper>
					{children}
				</>
			)}
		</OrganizationContentWrapper>
	);
};
